import { OutreachTemplateType } from 'clients/OutreachTemplateclient/OutreachTemplateClient.types';
import { OutreachInformationWhyNotLabel } from 'shared/legacy/contexts/CandidateContext/types';
import { OutreachType } from 'types/outreach';

export type CandidateOutreachButtonOption = {
  key: 'call' | OutreachTemplateType;
  label: string;
  icon: React.ReactNode;
  disabled: boolean;
  tooltip?: OutreachInformationWhyNotLabel;
};

export const OutreachTemplateToEditorType: Record<string, OutreachType> = {
  Call: OutreachType.Phone,
  Email: OutreachType.Email,
  Indeed: OutreachType.Indeed,
  WhatsApp: OutreachType.Whatsapp,
  LinkedIn: OutreachType.Linkedin,
  'LinkedIn InMail': OutreachType.LinkedinInmail,
  'Werk.nl': OutreachType.Werknl,
  RJCommHub: OutreachType.RJCommHub,
};
